import { ShieldCheck } from 'lucide-react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';

/*
  What the repository has to configure. One row per surface, each leading to its own page —
  see `<SettingsMenu>` for why the lists are not inlined here.

  **Every catalog this suite grows belongs on this page**, never as a sidebar row: the rail
  keeps one entry per module, and the test is whether a reader goes somewhere to do work or to
  change what the work draws on. That is the same arrangement Human Resources uses, and the
  reason its rail has not grown a row per vocabulary.

  Unlike Personnel's rows, these carry the MODULE's own key rather than one each. The
  classification catalog has no separate module and no keys of its own — maintaining the
  vocabulary a document draws on is an ordinary write to this module, and inventing
  `repository.settings` would be a gate with no endpoint behind it to enforce it.
*/
const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'classifications',
    label: 'Classifications',
    description:
      'The information classifications a controlled document carries — the four of the Information Classification Matrix, and whatever else this organization recognises.',
    icon: ShieldCheck,
    to: '/repository/settings/classifications',
    permission: 'repository.read',
  },
];

/**
 * Repository → Settings.
 *
 * A menu of what the module configures, and nothing else. It holds one row today; the shape is
 * what matters, because the next catalog this suite grows goes here rather than into the rail.
 */
export function RepositorySettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Document Management', 'Repository', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-auto p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          {/*
            One line, saying the thing the menu cannot: where the documents went. Without it a
            reader who came looking for files reads this row and concludes the module has
            nothing else.
          */}
          <p className="text-xs text-slate-500">
            The vocabularies a controlled document draws on. Documents and folders themselves
            live on Browse.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
